import React, { useState } from 'react';
import { Form, Button, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import api from '../seller-apis/api';



function AddnewAddressSeller(props) {

  const {sellerAddress} = useSelector(state => state.profileReducer)

  const [name, setName] = useState();
  const [mobile, setMobile] = useState();
  const [address, setAddress] = useState();
  const [zipcode, setZipcode] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [email, setEmail] = useState();
  const [gstNumber, setGstNumber] = useState();

  // Toast States
  const [toastname, settoastname] = useState("none");
  const [toastmobile, settoastmobile] = useState("none");
  const [toastaddress, settoastaddress] = useState("none");
  const [toastzip, settoastzip] = useState("none");
  const [toastcity, settoastcity] = useState("none");
  const [toaststate, settoaststate] = useState("none");
  const [toastemail, settoastemail] = useState("none");
  const [toastgst, settoastgst] = useState("none");


  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }

  const GSTNumberValidation = (text = "") => {
    let regex = new RegExp("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");
    if (regex.test(text.toUpperCase())) {
      return true;
    }
    return false;
  }

  function AddAddress() {
    let vendAddStat;
    settoastname("none");
    settoastmobile("none");
    settoastaddress("none");
    settoastzip("none");
    settoastcity("none");
    settoaststate("none");
    settoastemail("none");
    settoastgst("none");
    if (name === undefined) {
      settoastname("block")
    }
    else if (gstNumber === undefined || !GSTNumberValidation(gstNumber)) {
      settoastgst("block")
    }
    else if (mobile === undefined || mobile.length !== 10) {
      settoastmobile("block")
    }
    else if (zipcode === undefined || zipcode.length !== 6) {
      settoastzip("block")
    }
    else if (state === undefined || state === "State") {
      settoaststate("block")
    }
    else if (address === undefined || !isNaN(address)) {
      settoastaddress("block")
    }
    else if (city === undefined || !isNaN(city)) {
      settoastcity("block")
    }
    else if (email === undefined || !email.includes("@") || !email.includes(".")) {
      settoastemail("block")
    }
    else {
      let data = {
        "gstNo":gstNumber,
        "address": address,
        "city": city,
        "country": "India",
        "email": email,
        "firstName": name,
        "phoneNumber": mobile,
        "state": state,
        "zipcode": zipcode
      }
      vendAddStat =  checkAddressConstraint()
      if(vendAddStat.status){
        api.seller.addAddress(data).then((res) => {
          setName("")
          setGstNumber("")
          setMobile("")
          setAddress("")
          setZipcode("")
          setCity("")
          setState("")
          setEmail("")
          props.response("success")
        }).catch(err => {
          console.log(err)
        })
      }
      else{
        props.response("info",vendAddStat.msg)
      }
    }
  }

  function checkAddressConstraint(){
    if(localStorage.getItem("vendorType") === "Friendly"){
      if(sellerAddress.length >= 3){
        return {"msg":"The limit for adding no. of addresses in the account has exceeded.","status":false}
      }
      else{
        return {"status":true}
      }
    }
    else if(localStorage.getItem("vendorType") === "Super Friendly"){
      if(sellerAddress.length >= 8){
        return {"msg":"The limit for adding no. of addresses in the account has exceeded.","status":false}
      }
      else{
        return {"status":true}
      }
    }
    else if(localStorage.getItem("vendorType") === "In-House"){
      if(sellerAddress.length >= 15){
        return {"msg":"The limit for adding no. of addresses in the account has exceeded.","status":false}
      }
      else{
        return {"status":true}
      }
    }
    else{
      return {"status":true}
    }
  }

  return (
    <>
      <div className='mb-4'>
        <Container>
          <Row className="details-container">
            <div className="col-12">
              <div class="mb-2">
              
                <input type="text" name="Number" placeholder='Name*' autocomplete="off" onChange={(e) => setName(e.target.value)} required className='profile-input' />
                {/* <label for="name" class="label-name ">
                  <span class="content-name in-col">
                    Name *
                  </span>
                </label> */}

              </div>
              <span className="toastAlert" style={{ "display": toastname }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter Name</span>
              {/* SL-1164 */}
              <div class="mb-2">
                <input type="text" placeholder='GST Number*' autocomplete="off" onChange={(e) => setGstNumber(e.target.value)} required className='profile-input' />
              </div>
              <span className="toastAlert" style={{ "display": toastgst }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter a valid GST Number</span>
            </div>
            <div className="col-6 mb-2">
              <div class="">
                <input type="number" autocomplete="off" value={mobile} onKeyDown={checkMinusInput} onChange={(e) => {
                  if (e.target.value.length <= 10) {
                    setMobile(e.target.value)
                  }
                }} onWheel={(e) => e.target.blur()} required  className='profile-input' placeholder='Mobile No*' />
                {/* <label for="name" class="label-name ">
                  <span class="content-name in-col">
                    Mobile No. *</span>
                </label> */}

              </div>
              <span className="toastAlert" style={{ "display": toastmobile }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter valid Mobile No.</span>
            </div>
            <div className="col-6 mb-2">
              <div class="">
                <input type="number" name="text" autocomplete="off" value={zipcode} onKeyDown={checkMinusInput} onChange={(e) => {
                  if (e.target.value.length <= 6) {
                    setZipcode(e.target.value)
                  }
                }}
                  onWheel={(e) => e.target.blur()} required  className='profile-input' placeholder='Zip/Postal Code*' />
                {/* <label for="name" class="label-name ">
                  <span class="content-name in-col">
                    Zip/Postal Code *</span>
                </label> */}

              </div>
              <span className="toastAlert" style={{ "display": toastzip }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please enter your zipcode</span>
            </div>
            <div className="col-12 mb-2">
              <Form.Select aria-label="Default select example" onChange={(e) => setState(e.target.value)}  className='profile-input'>

                <option value="State" selected disabled>State</option>
                <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                <option value="Andhra Pradesh"> Andhra Pradesh</option>
                <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                <option value="Assam">Assam</option>
                <option value="Bihar">Bihar</option>
                <option value="Chandigarh">Chandigarh</option>
                <option value="Chhattisgarh">Chhattisgarh</option>
                <option value="Dadra and Nagar Haveli andDaman and Diu">Dadra and Nagar Haveli and
                  Daman & Diu</option>
                <option value="Delhi">Delhi</option>
                <option value="Goa">Goa</option>
                <option value="Gujarat">Gujarat</option>
                <option value="Haryana">Haryana</option>
                <option value="Himachal Pradesh">Himachal Pradesh</option>
                <option value="JammuKashmir">Jammu & Kashmir</option>
                <option value="Jharkhand">Jharkhand</option>
                <option value="Karnataka">Karnataka</option>
                <option value="Kerela">Kerela</option>
                <option value="Ladakh">Ladakh</option>
                <option value="Lakshadweep">Lakshadweep</option>
                <option value="Madhya Pradesh">Madhya Pradesh</option>
                <option value="Maharashtra">Maharashtra</option>
                <option value="Manipur"> Manipur</option>
                <option value="Meghalaya">Meghalaya</option>
                <option value="Mizoram">Mizoram</option>
                <option value="Nagaland">Nagaland</option>
                <option value="Orissa">Orissa</option>
                <option value="Punjab">Punjab</option>
                <option value="Puducherry">Puducherry</option>
                <option value="Rajasthan">Rajasthan</option>
                <option value="Sikkim">Sikkim</option>
                <option value="Tamil Nadu">Tamil Nadu</option>
                <option value="Telangana">Telangana</option>
                <option value="Tripura">Tripura</option>
                <option value="Uttar Pradesh">Uttar Pradesh</option>
                <option value="Uttarakhand">Uttarakhand</option>
                <option value="West Bengal">West Bengal</option>
              </Form.Select>
              <span className="toastAlert" style={{ "display": toaststate }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please select your state</span>
            </div>
            <div className="col-12 mb-2">
              <div class="">
                <input type="text" name="text" autocomplete="off" onChange={(e) => setAddress(e.target.value)} required  className='profile-input' placeholder='Address*' />
                {/* <label for="name" class="label-name ">
                  <span class="content-name in-col">
                    Address *</span>
                </label> */}

              </div>
              <span className="toastAlert" style={{ "display": toastaddress }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter a valid Address</span>
            </div>
            <div className="col-6 mb-2">
              <div class="">
                <input type="text" name="text" autocomplete="off" onChange={(e) => setCity(e.target.value)} required  className='profile-input' placeholder='City*' />
                {/* <label for="name" class="label-name ">
                  <span class="content-name in-col">
                    City *</span>
                </label> */}

              </div>
              <span className="toastAlert" style={{ "display": toastcity }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please enter your city</span>
            </div>
            <div className="col-6 mb-2">
              <div class="">
                <input type="text" name="text" autocomplete="off" onChange={(e) => setEmail(e.target.value)} required  className='profile-input' placeholder='Email' />
                {/* <label for="name" class="label-name ">
                  <span class="content-name in-col">
                    Email</span>
                </label> */}

              </div>
              <span className="toastAlert" style={{ "display": toastemail }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please enter a valid email address</span>
            </div>
          </Row>

        </Container>
        <div className="d-grid gap-2 mt-3">
          <Button variant="secondary" size="lg" onClick={AddAddress}>
            Add Address
          </Button>



        </div>
      </div>
    </>
  )
}




export default AddnewAddressSeller;
